import { useCallback, useMemo } from "react";
import useRequest from "./useRequest"
import useSortObject from "./useSortObject";
import { API_CONNECTED_OBJECT, API_USER, BASE_ADMIN } from "../constants/api";
import { OrderType, PaginationResType } from "../types/pagination";
import { AllConnectedObjectType } from "../types/connected-object";

const useUserObjects = () => {
  const {
    request,
    response,
  } = useRequest<AllConnectedObjectType>();

  const {colToSort, setColToSort, connectedObjects} = useSortObject(response?.data);
  const metaData = useMemo<PaginationResType | undefined>(() => (response ? {...response} : undefined), [response]);

  const getObjectOf = useCallback((userId: number, page: number = 1, limit: number = 10 ) => {
    request(BASE_ADMIN, `${API_USER}/${userId}/${API_CONNECTED_OBJECT}?page=${page}&limit=${limit}`, {secure: true});
  }, [request])
  
  const handleSort = useCallback((target: string, value: OrderType) => {
    setColToSort({target, value});
  }, [setColToSort])

  return {
    getObjectOf, handleSort,
    connectedObjects, colSorted: colToSort?.target, metaData 
  }
}

export default useUserObjects;